import {SODeleteEntity} from '../../core/entity/so-delete-entity';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteEntity extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteEntity;
}